module.exports = __webpack_public_path__ + "static/smart-store-logo-easy-e8980541715cbc7db9042c1870348f03.svg";